<template>
    <div>
	    <md-card-content>
		    <div class="relative" style="min-height: 200px;">
			    <md-table v-model="contacts" class="paginated-table" table-header-color="blue">
				    <md-table-row v-if="contacts.length > 0" slot="md-table-row" slot-scope="{ item }">
					    <md-table-cell md-label="Fonction">
						    {{ item.role }}
					    </md-table-cell>
					    <md-table-cell md-label="Nom">
						    {{ shortedGender(item.gender) + ' ' + item.full_name }}
					    </md-table-cell>
					    <md-table-cell md-label="Téléphone">
						    <div v-if="item.phone">T : {{ item.phone }}</div>
						    <div v-if="item.mobile">P : {{ item.mobile }}</div>
					    </md-table-cell>
					    <md-table-cell md-label="">
						    <div class="flex items-center justify-end space-x-1.5">
							    <div>
								    <md-button class="md-icon-button md-raised md-info" :href="'mailto:' + item.email" :disabled="!item.email">
									    <font-awesome-icon class="md-icon" :icon="['fa', 'envelope']" />
								    </md-button>
								    <md-tooltip v-if="item.email" md-direction="top" style="min-width: max-content !important;">{{ item.email }}</md-tooltip>
							    </div>
							    <div>
								    <md-button class="md-icon-button md-raised md-warning" @mousedown="goToRoute($event, 'Client Contact Edit', { idContact: item.id }, {})">
									    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
								    </md-button>
								    <md-tooltip md-direction="top">Modifier</md-tooltip>
							    </div>
							    <div>
								    <md-button class="md-icon-button md-raised md-danger" @click="handleDelete(item)">
									    <font-awesome-icon class="md-icon" :icon="['fa', 'ban']" />
								    </md-button>
								    <md-tooltip md-direction="top">Supprimer</md-tooltip>
							    </div>
						    </div>
					    </md-table-cell>
				    </md-table-row>
				    <md-table-empty-state v-if="!loading"
				                          md-label="Pas de contrats trouvés"
				                          md-description="Essayez une recherche différente">
				    </md-table-empty-state>
			    </md-table>
			    <div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
				    <div class="h-full w-full flex items-center justify-center">
					    <md-progress-spinner class="md-white" md-mode="indeterminate"
					                         :md-diameter="50" :md-stroke="4"></md-progress-spinner>
				    </div>
			    </div>
		    </div>
	    </md-card-content>
	    <md-card-actions md-alignment="space-between">
		    <p class="card-category">
			    Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
		    </p>
		    <pagination
			    class="pagination-no-border pagination-info"
			    v-model="pagination.currentPage"
			    :per-page="pagination.perPage"
			    :total="pagination.total"
			    @input="getContacts">
		    </pagination>
	    </md-card-actions>
    </div>
</template>

<script>
import { Pagination } from "../../../components";

import routerMixin from "../../../mixins/router-mixin";

export default {
    name: "ClientContacts",
	components: {
		Pagination
	},
	mixins: [routerMixin],
	data() {
		return {
			contacts: [],
			pagination: {
				perPage: 10,
				currentPage: 1,
				perPageOptions: [10, 25, 50],
				total: 0
			},
			loading: true
		}
	},
	computed: {
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.searchedData.length > 0 ? this.searchedData.length : this.contacts.length;
		},
	},
	methods: {
		async getContacts() {
			const response = await this.$store.dispatch('clients/getClientContacts', {
				client_id: this.$route.params.id,
				page: this.pagination.currentPage,
				perPage: this.pagination.perPage
			})

			this.contacts = response.data.data
			this.pagination.total = response.data.total
			this.loading = false
		},
        handleDelete(item) {
            this.$swal.fire({
                title: "Êtes-vous sûr ?",
                text: `Voulez-vous vraiment supprimer ce contact ?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-warning",
                confirmButtonText: "Supprimer",
                cancelButtonText: "Annuler",
                buttonsStyling: false
            }).then(async result => {
                if(result.value) {
                    try {
                        await this.$store.dispatch("contacts/deleteContact", item)
                        await this.$store.dispatch("alerts/success","Contact supprimé");
                        this.$emit('deleted')
                    } catch(e) {
                        await this.$store.dispatch("alerts/error","Une erreur est survenue");
                    }
                }
            });
        },
        shortedGender(gender) {
            return gender === "Monsieur" ? "Mr" : gender === "Madame" ? "Mme" : ''
        }
    },
	mounted() {
		this.getContacts()
	}
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-datatable {
        max-height: 33px;
        min-height: 33px;
        width: 100%;
        .md-ripple {
            padding: 0 1rem !important;
        }
    }
    .md-table-cell-container .md-button {
        width: auto;

        .md-icon {
            font-size: .875rem !important;
            min-width: .875rem !important;
            height: .875rem !important;
        }
    }
    .md-table-head .md-table-head-label {
        color: #00bcd4 !important;
    }
    .md-list.md-dense {
        padding: 0;
        margin-top: .5rem;

        .md-list-item-content.md-ripple {
            min-height: 25px;
            padding: 0 15px;

            .md-icon {
                font-size: .25rem !important;
                min-width: .25rem !important;
                height: .25rem !important;
                color: rgba(0,0,0,.54) !important;
            }
            .md-icon:first-child {
                margin-right: .5rem;
            }
            span {
                position: relative;
                font-weight: 300;
                font-size: 14px;
            }
        }
    }
}
</style>
